export const TRADEIN = 'TRADEIN'
export const CERTIFICATE = 'CERTIFICATE'
export const COMM_DIRECTOR = 'COMM_DIRECTOR'
export const PROMO = 'PROMO'
export const EMPLOYEE = 'EMPLOYEE'
export const EXTRA = 'EXTRA'
export const BLACKFRIDAY = 'BLACKFRIDAY'

export const extraOptions = [
  { value: '', label: 'Не выбрано' },
  { value: 'OVER', label: 'Овер' },
  { value: 'OVER_PEREKIDKA', label: 'Овер + перекидка' },
  { value: 'OVER_NDS', label: 'Овер НДС юр лицо' }
]

export const getExtraOptionsName = options => {
  switch (options) {
    case 'OVER':
      return 'Овер'
    case 'OVER_PEREKIDKA':
      return 'Овер + перекидка'
    case 'OVER_NDS':
      return 'Овер НДС юр лицо'
    case 'OVER_SECRET_DAD':
      return 'Овер секрет отца'
    default:
      return '-'
  }
}
